module.exports = __webpack_public_path__ + "static/media/home-slider-banner-8.5dd6015d.png";